import type { SkedEnvConfig } from "./types";
import devConfig from "./env.dev";
import stagingConfig from "./env.staging";
import productionConfig from "./env.production";

const configs: Record<string, SkedEnvConfig> = {
  development: devConfig,
  dev: devConfig,
  staging: stagingConfig,
  production: productionConfig,
};

// Preview environments run Vite in development mode while using staging
// services. Keep browser configuration aligned with the explicit API target.
const env = process.env.SKED_API_ENV || process.env.NODE_ENV || "development";
const config: SkedEnvConfig = configs[env] || devConfig;

(window as any).__SKED_CONFIG__ = {
  ...config,
  env,
  buildVersion: process.env.SKED_APP_BUILD_HASH || "unknown",
};

export default config;
export type { SkedEnvConfig };
